/**
 * @flow
 * @relayHash e582668e76c96c3b85199a9ed72d62d8
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type NonIndexablePagesTable_project$ref = any;
export type indexing_IndexingCategory_NonIndexablePagesTable_QueryVariables = {|
  host: string
|};
export type indexing_IndexingCategory_NonIndexablePagesTable_QueryResponse = {|
  +project: ?{|
    +$fragmentRefs: NonIndexablePagesTable_project$ref
  |}
|};
export type indexing_IndexingCategory_NonIndexablePagesTable_Query = {|
  variables: indexing_IndexingCategory_NonIndexablePagesTable_QueryVariables,
  response: indexing_IndexingCategory_NonIndexablePagesTable_QueryResponse,
|};
*/


/*
query indexing_IndexingCategory_NonIndexablePagesTable_Query(
  $host: String!
) {
  project(host: $host) {
    ...NonIndexablePagesTable_project
    id
  }
}

fragment NonIndexablePagesTable_project on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        countNoindexTypesNoindexedPages(sitemapFilter: {showInSitemap: true, showNotInSitemap: true}, url: {operator: AND, values: []}, sourceUrl: {operator: AND, values: []}) {
          type
          count
        }
        noindexedPages(offset: 0, limit: 20, url: {operator: AND, values: []}, sourceUrl: {operator: AND, values: []}, noindexTypeFilters: [], sitemapFilter: {showInSitemap: true, showNotInSitemap: true}) {
          count
          edges {
            node {
              ...NonIndexablePagesRow_issue
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment NonIndexablePagesRow_issue on NoindexedPage {
  id
  type
  severity
  url
  source_url
  noindex_types
  sitemap_url
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "Literal",
  "name": "offset",
  "value": 0,
  "type": "Int"
},
v3 = {
  "kind": "Literal",
  "name": "sitemapFilter",
  "value": {
    "showInSitemap": true,
    "showNotInSitemap": true
  },
  "type": "SitemapFilter"
},
v4 = {
  "operator": "AND",
  "values": ([]/*: any*/)
},
v5 = {
  "kind": "Literal",
  "name": "sourceUrl",
  "value": v4,
  "type": "TextFilters"
},
v6 = {
  "kind": "Literal",
  "name": "url",
  "value": v4,
  "type": "TextFilters"
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "indexing_IndexingCategory_NonIndexablePagesTable_Query",
  "id": null,
  "text": "query indexing_IndexingCategory_NonIndexablePagesTable_Query(\n  $host: String!\n) {\n  project(host: $host) {\n    ...NonIndexablePagesTable_project\n    id\n  }\n}\n\nfragment NonIndexablePagesTable_project on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        countNoindexTypesNoindexedPages(sitemapFilter: {showInSitemap: true, showNotInSitemap: true}, url: {operator: AND, values: []}, sourceUrl: {operator: AND, values: []}) {\n          type\n          count\n        }\n        noindexedPages(offset: 0, limit: 20, url: {operator: AND, values: []}, sourceUrl: {operator: AND, values: []}, noindexTypeFilters: [], sitemapFilter: {showInSitemap: true, showNotInSitemap: true}) {\n          count\n          edges {\n            node {\n              ...NonIndexablePagesRow_issue\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment NonIndexablePagesRow_issue on NoindexedPage {\n  id\n  type\n  severity\n  url\n  source_url\n  noindex_types\n  sitemap_url\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "indexing_IndexingCategory_NonIndexablePagesTable_Query",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "NonIndexablePagesTable_project",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "indexing_IndexingCategory_NonIndexablePagesTable_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              v2
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "countNoindexTypesNoindexedPages",
                        "storageKey": "countNoindexTypesNoindexedPages(sitemapFilter:{\"showInSitemap\":true,\"showNotInSitemap\":true},sourceUrl:{\"operator\":\"AND\",\"values\":[]},url:{\"operator\":\"AND\",\"values\":[]})",
                        "args": [
                          v3,
                          v5,
                          v6
                        ],
                        "concreteType": "CountType",
                        "plural": true,
                        "selections": [
                          v7,
                          v8
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "noindexedPages",
                        "storageKey": "noindexedPages(limit:20,noindexTypeFilters:[],offset:0,sitemapFilter:{\"showInSitemap\":true,\"showNotInSitemap\":true},sourceUrl:{\"operator\":\"AND\",\"values\":[]},url:{\"operator\":\"AND\",\"values\":[]})",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "limit",
                            "value": 20,
                            "type": "Int"
                          },
                          {
                            "kind": "Literal",
                            "name": "noindexTypeFilters",
                            "value": [],
                            "type": "[String]"
                          },
                          v2,
                          v3,
                          v5,
                          v6
                        ],
                        "concreteType": "NoindexedPageConnection",
                        "plural": false,
                        "selections": [
                          v8,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "NoindexedPageEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "NoindexedPage",
                                "plural": false,
                                "selections": [
                                  v9,
                                  v7,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "severity",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "url",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "source_url",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "noindex_types",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "sitemap_url",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v9
                    ]
                  }
                ]
              }
            ]
          },
          v9
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6e8b4fa5b4ced046a81f13fa13c44350';
module.exports = node;
